import { useGetGuidParam } from '@risksmart-app/components/src/routes/routes.utils';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import InternalAuditFindingForm from 'src/pages/assessments/forms/InternalAuditFindingForm';
import { useAssessmentTypeConfig } from 'src/pages/assessments/useAssessmentTypeConfig';
import type { ObjectWithContributors } from 'src/rbac/Permission';

interface Props {
  assessment?: ObjectWithContributors;
}

const InternalAuditResultCreateTab: FC<Props> = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation(['common']);
  const assessmentId = useGetGuidParam('assessmentId');
  const {
    routing: { resultsRegisterUrl },
  } = useAssessmentTypeConfig('internal_audit_report');
  const onDismiss = (saved?: boolean) => {
    if (!saved) {
      navigate(resultsRegisterUrl(assessmentId));
    }
  };

  return (
    <InternalAuditFindingForm
      readonly={!props.assessment}
      parentAssessment={props.assessment}
      onDismiss={onDismiss}
      assessmentId={assessmentId}
      formType={location.state?.type}
      ratingResultType={location.state?.ratingType}
      preselectedAssessedItemIds={location.state?.ids}
      navigateToResults={true}
      showAssessmentSelector={true}
      header={t('details')}
    />
  );
};

export default InternalAuditResultCreateTab;
